<template>
	<v-container class="pa-sm-4 pa-1">
		<v-card flat shaped elevation="4" outlined class="pa-0">
			<v-card-text class="pb-0 pt-0 pl-1 pr-1">
				<v-row class="d-flex justify-space-between pa-2">
					<v-col class="d-flex justify-start">
						<img :src="publicPath + 'login_logo.png'" width="200vh" />
					</v-col>
					<v-col class="d-flex justify-end">
						<div :class="['text-body-2', 'pt-2', 'pb-0']">
							{{ $t('labels.obSurveyNumber') }}
						</div>
					</v-col>
				</v-row>
				<v-row class="d-flex justify-center">
					<v-card-title class="text-center pa-0 pl-3 pr-3">
						{{ $t('titles.surveyAboutCandidateSatisfaction') }}
						{{ ' / ' + $t('titles.surveyAboutCandidateSatisfaction_eng') }}
					</v-card-title>
				</v-row>
				<v-row class="d-flex justify-center">
					<div :class="['text-h6', 'justify-center', 'align-center', 'pb-0', 'pt-0', 'pl-3', 'pr-3']">
						{{ courseInfo }}
					</div>
				</v-row>
				<v-row class="d-flex justify-center">
					<div :class="['text-h6', 'justify-center', 'align-center', 'pb-0', 'pt-0', 'pl-3', 'pr-3']">
						{{ $t('texts.surveyRatingInfo') }}
						{{ ' / ' + $t('texts.surveyRatingInfo_eng') }}
					</div>
				</v-row>
				<v-container class="pa-1 pa-md-16 pt-2">
					<v-row class="pa-1 pa-md-16 pb-4">
						<v-container v-if="initialLoad">
							<v-row v-for="(item, key) in candidateSurvey.teachers" :key="key">
								<v-col cols="12">
									<v-card flat class="pa-0 ma-0" color="shade">
										<v-col cols="12" class="pb-0">
											<div :class="['text-body-1', 'pt-2', 'pb-0']">
												{{ $t('texts.teacherSurveyQuestion') + item['full_name'] + '? / ' }}
												{{ $t('texts.teacherSurveyQuestion_eng') + item['full_name'] + '?' }}
											</div>
										</v-col>
										<v-col cols="12" class="pb-0 pt-0">
											<v-radio-group
												v-model="item['teacher_rating']"
												row
												mandatory
												hide-details="auto"
											>
												<v-container
													class="d-flex flex-wrap justify-space-between pl-md-2 pr-md-2 pl-0 pr-0 pt-0"
												>
													<v-radio
														label="1"
														:value="1"
														class="pl-sm-4 pt-sm-0 pl-0 pt-4"
													></v-radio>
													<v-radio label="2" :value="2" class="pt-sm-0 pt-4"></v-radio>
													<v-radio label="3" :value="3" class="pt-sm-0 pt-4"></v-radio>
													<v-radio label="4" :value="4" class="pt-sm-0 pt-4"></v-radio>
													<v-radio label="5" :value="5" class="pr-4 pt-sm-0 pt-4"></v-radio>
												</v-container>
											</v-radio-group>
										</v-col>
										<v-col cols="12" v-if="item['teacher_rating'] <= 3" class="pt-2 pb-8">
											<TextArea
												v-model="item['teacher_rating_explaination']"
												:label="
													'* ' +
													$t('texts.pleaseExplainRating') +
													' / ' +
													$t('texts.pleaseExplainRating_eng')
												"
												:errorBorder="!teachersValidation[key]['full_name']"
												rows="3"
											></TextArea>
										</v-col>
										<v-col cols="12" v-else class="pt-2 pb-8">
											<TextArea
												v-model="item['teacher_rating_explaination']"
												:label="
													$t('texts.pleaseExplainRating') +
													' / ' +
													$t('texts.pleaseExplainRating_eng')
												"
												rows="3"
											></TextArea>
										</v-col>
									</v-card>
								</v-col>
							</v-row>
						</v-container>
						<v-col cols="12">
							<v-card flat class="pa-0 ma-0" color="shade">
								<v-col cols="12" class="pb-0">
									<div :class="['text-body-1', 'pt-2', 'pb-0']">
										{{ $t('texts.surveyQuestion1') + ' / ' }}
										{{ $t('texts.surveyQuestion1_eng') }}
									</div>
								</v-col>
								<v-col cols="12" class="pt-0 pb-0">
									<v-radio-group
										v-model="candidateSurvey.office_rating"
										row
										mandatory
										hide-details="auto"
									>
										<v-container
											class="d-flex flex-wrap justify-space-between pl-md-2 pr-md-2 pl-0 pr-0 pt-0"
										>
											<v-radio label="1" :value="1" class="pl-sm-4 pl-0 pt-sm-0 pt-4"></v-radio>
											<v-radio label="2" :value="2" class="pt-sm-0 pt-4"></v-radio>
											<v-radio label="3" :value="3" class="pt-sm-0 pt-4"></v-radio>
											<v-radio label="4" :value="4" class="pt-sm-0 pt-4"></v-radio>
											<v-radio label="5" :value="5" class="pr-4 pt-sm-0 pt-4"></v-radio>
										</v-container>
									</v-radio-group>
								</v-col>
								<v-col cols="12" v-if="candidateSurvey.office_rating <= 3" class="pt-2 pb-8">
									<TextArea
										v-model="candidateSurvey.office_rating_explaination"
										:errorBorder="!candidateSurveyValidation.office_rating_explaination"
										rows="3"
										:label="
											'* ' +
											$t('texts.pleaseExplainRating') +
											' / ' +
											$t('texts.pleaseExplainRating_eng')
										"
									></TextArea>
								</v-col>
								<v-col cols="12" v-else class="pt-2 pb-8">
									<TextArea
										v-model="candidateSurvey.office_rating_explaination"
										:errorBorder="!candidateSurveyValidation.office_rating_explaination"
										rows="3"
										:label="
											$t('texts.pleaseExplainRating') +
											' / ' +
											$t('texts.pleaseExplainRating_eng')
										"
									></TextArea>
								</v-col>
							</v-card>
						</v-col>

						<v-col cols="12">
							<v-card flat class="pa-0 ma-0" color="shade">
								<v-col cols="12" class="pb-0">
									<div :class="['text-body-1', 'pt-2']">
										{{ $t('texts.surveyQuestion2') + ' / ' }}
										{{ $t('texts.surveyQuestion2_eng') }}
									</div>
								</v-col>
								<v-col cols="12" class="pt-0 pb-0">
									<v-radio-group
										v-model="candidateSurvey.course_rating"
										row
										mandatory
										hide-details="auto"
									>
										<v-container
											class="d-flex flex-wrap justify-space-between pl-md-2 pr-md-2 pl-0 pr-0 pt-0"
										>
											<v-radio label="1" :value="1" class="pl-sm-4 pl-0 pt-sm-0 pt-4"></v-radio>
											<v-radio label="2" :value="2" class="pt-sm-0 pt-4"></v-radio>
											<v-radio label="3" :value="3" class="pt-sm-0 pt-4"></v-radio>
											<v-radio label="4" :value="4" class="pt-sm-0 pt-4"></v-radio>
											<v-radio label="5" :value="5" class="pr-4 pt-sm-0 pt-4"></v-radio>
										</v-container>
									</v-radio-group>
								</v-col>
								<v-col cols="12" v-if="candidateSurvey.course_rating <= 3" class="pt-2 pb-8">
									<TextArea
										v-model="candidateSurvey.course_rating_explaination"
										:errorBorder="!candidateSurveyValidation.course_rating_explaination"
										rows="3"
										:label="
											'* ' +
											$t('texts.pleaseExplainRating') +
											' / ' +
											$t('texts.pleaseExplainRating_eng')
										"
									></TextArea>
								</v-col>
								<v-col cols="12" v-else class="pt-2 pb-8">
									<TextArea
										v-model="candidateSurvey.course_rating_explaination"
										:errorBorder="!candidateSurveyValidation.course_rating_explaination"
										rows="3"
										:label="
											$t('texts.pleaseExplainRating') +
											' / ' +
											$t('texts.pleaseExplainRating_eng')
										"
									></TextArea>
								</v-col>
							</v-card>
						</v-col>

						<v-col cols="12">
							<v-card flat class="pa-0 ma-0" color="shade">
								<v-col cols="12" class="pt-6 pb-8">
									<TextArea
										v-model="candidateSurvey.remark"
										:errorBorder="!candidateSurveyValidation.remark"
										:label="
											'* ' + $t('fields.remarkPraise') + ' / ' + $t('fields.remarkPraise_eng')
										"
										rows="3"
									></TextArea>
								</v-col>
							</v-card>
						</v-col>
					</v-row>

					<v-row class="pt-12">
						<v-col cols="12" class="d-flex justify-center">
							<v-btn class="ma-2 pa-6" color="primary" variant="text" @click="saveClick">
								{{ $t('buttons.save') + ' / ' + $t('buttons.save_eng') }}
							</v-btn>
						</v-col>
					</v-row>
					<v-row>
						<Modal :show-modal="showModal">
							<v-row class="pa-2">
								<v-col cols="12" class="d-flex justify-center pt-0">
									<img :src="publicPath + 'login_logo.png'" width="200vh" height="50vh" />
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" class="d-flex justify-center pb-0">
									<div :class="['text-h6', 'pb-0', 'pt-2']">
										{{ $t('texts.surveyCompletedSuccessfully') }}
									</div>
								</v-col>
								<v-col cols="12" class="d-flex justify-center pt-0">
									<div :class="['text-h6', 'pb-2', 'pt-0']">
										{{ $t('texts.tenPointsAddedToYourAccount') }}
									</div>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" class="d-flex justify-center pb-0">
									<div :class="['text-h6', 'pb-0', 'pt-2']">
										{{ $t('texts.surveyCompletedSuccessfully_eng') }}
									</div>
								</v-col>
								<v-col cols="12" class="d-flex justify-center pt-0">
									<div :class="['text-h6', 'pb-2', 'pt-0']">
										{{ $t('texts.tenPointsAddedToYourAccount_eng') }}
									</div>
								</v-col>
							</v-row>
							<v-spacer> </v-spacer>
							<v-row>
								<v-col cols="12" class="d-flex justify-center">
									<v-btn class="ma-2 pa-6" color="primary" variant="text" @click="closeModal">
										{{ $t('buttons.close') + ' / ' + $t('buttons.close_eng') }}
									</v-btn>
								</v-col>
							</v-row>
						</Modal>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import TextArea from '../../trinkets/TextArea';
import Modal from '../../trinkets/Modal';
import Survey from '../../../models/Survey';

export default {
	name: 'CandidateSurvey',
	components: { TextArea, Modal },
	data() {
		return {
			publicPath: process.env.BASE_URL,
			candidateSurvey: new Survey({}),
			candidateSurveyValidation: new Survey({}, true),
			initialLoad: false,
			grades: [5, 4, 3, 2, 1],
			teachersValidation: [],
			courseInfo: '',
			showModal: false,
		};
	},

	methods: {
		closeModal() {
			this.showModal = false;
			window.location.href = 'https://www.adrialibar.com/';
		},
		getCandidateSurveyToken() {
			let vm = this;
			const token = this.$route.params.token;
			this.$APICall('get', 'candidate-survey-token/' + token, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data.items));
					vm.candidateSurvey.teachers = usableData;
					vm.teachersValidation = JSON.parse(JSON.stringify(data.items));
					vm.courseInfo = data.courseInfo;
					for (const teacher of vm.teachersValidation) {
						teacher['teacher_id'] = true;
						teacher['full_name'] = true;
					}
					vm.initialLoad = true;
				} else {
					window.location.href = 'https://www.adrialibar.com/';
				}
			});
		},
		saveClick() {
			let success = true;
			let errorMessages = '';

			for (let i = 0; i < this.candidateSurvey.teachers.length; i++) {
				if (this.candidateSurvey.teachers[i].teacher_rating <= 3) {
					if (!this.candidateSurvey.teachers[i].hasOwnProperty('teacher_rating_explaination')) {
						this.teachersValidation[i].full_name = false;
						success = false;
					} else {
						if (this.candidateSurvey.teachers[i].teacher_rating_explaination.length > 750) {
							this.teachersValidation[i].full_name = false;
							success = false;
							errorMessages +=
								this.$t('alerts.lengthError')
									.replace('%field%', this.$t('texts.pleaseExplainRating'))
									.replace('%length%', '750') + '<br />';
						} else {
							this.teachersValidation[i].full_name = true;
						}
					}
				} else {
					this.teachersValidation[i].full_name = true;
				}
			}

			if (!this.candidateSurvey.course_rating) {
				success = false;
				this.candidateSurveyValidation.course_rating = false;
			} else {
				this.candidateSurveyValidation.course_rating = true;
			}

			if (!this.candidateSurvey.office_rating) {
				success = false;
				this.candidateSurveyValidation.office_rating = false;
			} else {
				this.candidateSurveyValidation.office_rating = true;
			}

			if (this.candidateSurvey.course_rating <= 3) {
				if (
					this.candidateSurvey.course_rating_explaination == null ||
					this.candidateSurvey.course_rating_explaination == ''
				) {
					success = false;
					this.candidateSurveyValidation.course_rating_explaination = false;
				} else {
					if (this.candidateSurvey.course_rating_explaination.length > 500) {
						this.candidateSurveyValidation.course_rating_explaination = false;
						errorMessages +=
							this.$t('alerts.lengthError')
								.replace('%field%', this.$t('texts.pleaseExplainRating'))
								.replace('%length%', '500') + '<br />';
					} else {
						this.candidateSurveyValidation.course_rating_explaination = true;
					}
				}
			} else {
				this.candidateSurveyValidation.course_rating_explaination = true;
			}

			if (this.candidateSurvey.office_rating <= 3) {
				if (
					this.candidateSurvey.office_rating_explaination == null ||
					this.candidateSurvey.office_rating_explaination == ''
				) {
					success = false;
					this.candidateSurveyValidation.office_rating_explaination = false;
				} else {
					if (this.candidateSurvey.office_rating_explaination.length > 500) {
						this.candidateSurveyValidation.office_rating_explaination = false;
						errorMessages +=
							this.$t('alerts.lengthError')
								.replace('%field%', this.$t('texts.pleaseExplainRating'))
								.replace('%length%', '500') + '<br />';
					} else {
						this.candidateSurveyValidation.office_rating_explaination = true;
					}
				}
			} else {
				this.candidateSurveyValidation.office_rating_explaination = true;
			}

			if (this.candidateSurvey.remark == null || this.candidateSurvey.remark == '') {
				success = false;
				this.candidateSurveyValidation.remark = false;
			} else {
				this.candidateSurveyValidation.remark = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				this.$APICall(
					'post',
					'candidate-survey/' + this.$route.params.token,
					this.candidateSurvey,
					(data, success) => {
						if (success) {
							this.showModal = true;
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					}
				);
			}
		},
	},
	created() {
		this.getCandidateSurveyToken();
	},
	mounted() {},
};
</script>

<style scoped></style>
